<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-btn outlined color="secondary" to="/admin">
          Back
        </v-btn>
        <v-btn class="ml-3" @click="triggerDownload" color="primary" :loading="loading">Export </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-col cols="6" md="3">
              <h3 class="primary--text"> Water </h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="waterRequests" :search="search">
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
              </template>
              <template v-slot:[`item.phoneNumber`]="{ item }">
                <router-link :to="`/session/${item.merchantRef}/messages`">{{item.phoneNumber}}</router-link>
             </template>
             <template v-slot:[`item.actions`]="{ item }">
                  <v-menu right bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon  v-bind="attrs" v-on="on">
                      <v-icon color="accent">mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
                    <v-list>
                        <v-list-item  @click="showRetryDialog(item)">
                            <v-list-item-title>Retry</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="retryDialog" persistent max-width="600">
    <v-card>
        <v-card-title>
            <v-row justify="center">
              <v-col md="6"> Retry Transaction </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row justify="center">
              <v-col md="4"> <v-icon large color="green darken-2">mdi-autorenew</v-icon> </v-col>
            </v-row>
            <v-row justify="center">
               <v-col md="8"><h3 class="mt-2"> Are you sure you want to retry the transaction? </h3></v-col>
            </v-row>
            </v-card-text>
        <v-card-actions>
        <v-btn color="primary" text @click="retryDialog = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="retry" :loading="loading">Retry</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Water',
  data: () => ({
    search: '',
    headers: [
      { text: 'Phone Number', value: 'phoneNumber' },
      { text: 'Amount', value: 'amount' },
      { text: 'Account', value: 'account' },
      { text: 'Status', value: 'status' },
      { text: 'Desc', value: 'statusDesc' },
      { text: 'Date', value: 'createdAt' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    retryDialog: false,
    billingRequest: [],
    loading: false
  }),
  computed: mapState({
    waterRequests: state => state.dash.waterRequests
  }),
  created () {
    this.$store.dispatch('dash/getWaterRequests')
  },
  methods: {
    ...mapActions({ retryTransaction: 'billing/retryTransaction', exportBillingRequestsSessions: 'dash/exportBillingRequestsSessions' }),
    showRetryDialog (item) {
      this.billingRequest = item
      this.retryDialog = true
    },
    retry () {
      this.loading = true
      this.retryTransaction(this.billingRequest).then(response => {
        this.loading = false
        this.retryDialog = false
        this.$store.dispatch('alert/displayAlert', { snackbar: false, color: 'success', message: response.data.message }, { root: true })
        this.$store.dispatch('billing/getRequests')
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
        this.loading = false
        this.retryDialog = false
      })
    },
    triggerDownload () {
      this.loading = true
      this.exportBillingRequestsSessions('WATER').then(response => {
        this.loading = false
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        const yourDate = new Date()
        link.download = `WATER_${yourDate.toISOString().split('T')[0]}.csv`
        link.click()
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    }
  }
}
</script>
